import { useCallback, useState } from "react";

export default function useBackoff({ initial = 1000, max = 10000, backoffFactor = 2 }) {
  const [current, setCurrent] = useState(initial);

  const next = useCallback(() => {
    setCurrent((c) => Math.min(c * backoffFactor, max));
  }, [backoffFactor, max]);

  const reset = useCallback(() => {
    setCurrent(initial);
  }, [initial]);

  return [current, { next, reset }];
}
